
// Helper function to process geo location data from Supabase
export const processGeoLocation = (geoLocation: any) => {
  let coordinates = { longitude: 13.404954, latitude: 52.520008 }; // Default coordinates for Berlin
  
  if (geoLocation !== undefined && geoLocation !== null) {
    try {
      // Handle string format (JSON string)
      if (typeof geoLocation === 'string') {
        try {
          const parsed = JSON.parse(geoLocation);
          if (parsed && typeof parsed === 'object') {
            // Handle PostGIS format with coordinates array
            if ('coordinates' in parsed && Array.isArray(parsed.coordinates) && parsed.coordinates.length >= 2) {
              coordinates = {
                longitude: Number(parsed.coordinates[0]),
                latitude: Number(parsed.coordinates[1])
              };
            } 
            // Handle direct lat/lng format
            else if ('latitude' in parsed && 'longitude' in parsed) {
              coordinates = {
                longitude: Number(parsed.longitude || 0),
                latitude: Number(parsed.latitude || 0)
              };
            }
          }
        } catch (e) {
          console.error('Error parsing geo_location string:', e);
        }
      } 
      // Handle object format
      else if (typeof geoLocation === 'object') {
        // Handle PostGIS format
        if ('coordinates' in geoLocation && Array.isArray(geoLocation.coordinates) && geoLocation.coordinates.length >= 2) {
          coordinates = {
            longitude: Number(geoLocation.coordinates[0]),
            latitude: Number(geoLocation.coordinates[1])
          };
        } 
        // Handle direct lat/lng format
        else if ('latitude' in geoLocation && 'longitude' in geoLocation) {
          coordinates = {
            longitude: Number(geoLocation.longitude || 0),
            latitude: Number(geoLocation.latitude || 0)
          };
        }
      }
    } catch (err) {
      console.error('Error processing geo_location:', err);
    }
  }
  
  return coordinates;
};

// Calculate distance between two points using the Haversine formula
export const calculateDistance = (lat1: number, lon1: number, lat2: number, lon2: number): number => {
  const R = 6371; // Radius of the Earth in km
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
    Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  const distance = R * c; // Distance in km
  
  return distance;
};
